import { initSentry } from '@imt/vue-toolbox/src/plugins/sentry';
import * as Sentry from '@sentry/vue';
import Vue from 'vue';

import router from '@/router';

initSentry({
    Vue,
    dsn: 'https://fe2b29769c1344f0b5d37012e1698188@o527262.ingest.sentry.io/5658862',
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.vueIntegration({
            tracingOptions: {
                trackComponents: true,
            },
        }),
    ],
    tracesSampleRate: 1.0,
});
